import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Typography
} from "@mui/material";
import React, { Fragment, useEffect } from "react";
import { useParams } from "react-router-dom";
import AppBarHome from "../components/AppBar/Home";
import { getData } from "../libs/firebase/firestore/getData";
import { useNavigateToTop } from "../libs/useNavigateToTop";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import GuidePdf from "../components/GuidePdf";
import { G, PDFDownloadLink } from "@react-pdf/renderer";
import AppBarGuide from "../components/AppBar/Guide";
import { updateData } from "../libs/firebase/firestore/updateData";
import { getAuth } from "firebase/auth";
import { deleteData } from "../libs/firebase/firestore/deleteData";
import BonsaiSoilCompositionGraph from "../components/BonsaiSoilCompositionGraph";
import LeafletMapGuideLocation from "../components/LeafletMapGuideLocation";
import LeafletMapRestricted from "../components/LeafletMapRestricted";
import { firebaseDateToDateTime } from "../utilities/firebaseDateToDateTime";
// import PlantList from "../components/PlantList/List";
// import Root from "../components/PlantList/Root";
const bonsaiStages= [
  {
    name: "Development",
    description: "The first stage of bonsai development is to establish the primary structure of the tree. This includes the trunk, the first branches and the nebari (surface roots).",
    stageNumber: 1,
  },
  {
    name: "Structural",
    description: "The second stage of bonsai development is to establish the secondary branches and the secondary structure of the tree.",  
    stageNumber: 2,
  },
  {
    name: "Refinement",
    description: "The third stage of bonsai development is to refine the tertiary branches and the tertiary structure of the tree.",
    stageNumber: 3,
  },
]



const Stage = ({stage,data, comment }) => {



  return (
    <Box>
       {/* Stage 1 */}
       <Typography variant="h5" gutterBottom>
          Yearly Chart
        </Typography>
        <Typography variant="body1" style={{ marginBottom: "1rem" }}>
          The coloured cells represent suitable times of year to perform each action. Refer to comments for further information from the guide author.
        </Typography>
          
        <YearlyChart        
         data={data}/>
         
       <Typography variant="h5" gutterBottom
        style={{
          marginTop: "1rem",
        }}
       >
          Comments
        </Typography>
         <Typography variant="body1" style={{ marginBottom: "1rem" }}>
          {comment || "No comments"}
        </Typography>
  
          
    </Box>
  );

}


const YearlyChart = ({ data =[] }) => {
  const colourCellTrue = "rgb(130, 147, 132)";
  const colourCellFalse = "white";
  const cellWidth = ".5rem";
  const cellHeight = "2rem";
  const cellPadding = "0rem";

  const numbers = [];
  for (let i = 1; i <= 36; i++) {
    numbers.push(i);
  }
  
  const months = [
    // just first three letters of the month
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  /**
   * A table. Each row is an element in the data array. The columns are the 12 months of the year, but with three columns per month. The colummn should be labeled with the month.
   */
  return (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
              <TableCell></TableCell>
                {months.map((month,index) => (
                  <Fragment
                    key={index}
                  >
                  {/* <TableCell></TableCell> */}
                    <TableCell 
                    key={index}
                    
                    style={
                      {
                        textAlign: "center",
                        backgroundColor: "lightgrey",
                        // width: "6rem",
                        height: "2rem",
                        border: "1px solid black",
                    }
                  }
                    
                    colSpan={3}>{month}</TableCell>
                  {/* <TableCell></TableCell> */}
                  </Fragment>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                (row.decans.length > 0 &&
                <TableRow key={index}>
                  <TableCell

                  style={{
                    backgroundColor: "lightgrey",
                    width: "6rem",
                    height: "2rem",
                    border: "1px solid black",
                    textAlign: "center",
                  
                  }}             
                  >{row.name}</TableCell>
                  {numbers.map((number) => (
                    <TableCell
                      key={number}
                      style={{
                        backgroundColor: row.decans.includes(number) ? colourCellTrue : colourCellFalse,
                        width: cellWidth,
                        height: cellHeight,
                        padding: cellPadding,
                        // if third column in the month, add a border to the right
                        borderRight: number % 3 === 0 ? "1px solid black" : "none",
                      }}
                    >
                    </TableCell>
                  ))}
                </TableRow>
              )))}
            </TableBody>
          </Table>
        </TableContainer>
  );

}


function ScreenGuide({}) {


  // get guide id from the url
  const { guideId } = useParams();
  
  const currentUser = getAuth().currentUser;


  const navigate = useNavigateToTop();

  // State for tasks data
  const [bonsaiGuide, setBonsaiGuide] = React.useState({});

  // loading state
  const [loading, setLoading] = React.useState(true);

 

  useEffect(() => {
    getData(`bonsai-guides/${guideId}`, (bonsaiGuideData) => {
      setBonsaiGuide(bonsaiGuideData);
      setLoading(false);
    });
  }, []);

  const handleVoteSuccess = () => {
    alert("Vote successful");
    // reload the guide
    getData(`bonsai-guides/${guideId}`, (bonsaiGuideData) => {
      setBonsaiGuide(bonsaiGuideData);
    });
  }

  const handleVoteFail = (e) => {
    alert("Vote failed");
    console.error(e)
  }

  const handleUpvote = () => {
    // get the current user id
    
    if (!currentUser) {
      alert("You must be signed in to upvote a guide");
      return;
    }

    const userId = currentUser.uid;

    // if user not signed in alert them
    if (!userId) {
      alert("You must be signed in to upvote a guide");
      return;
    }

    // check if the user has already voted
    if (bonsaiGuide.upVotes && bonsaiGuide.upVotes.includes(userId)) {
      alert("You have already upvoted this guide");
      return;
    }

    let currentUpvotes = bonsaiGuide.upVotes || [];
    const currentDownvotes = bonsaiGuide.downVotes || [];

    // add the user id to the upVotes array
    const upVotes = [...currentUpvotes, userId];

    // if user id is in the downVotes array, remove it
    const downVotes = currentDownvotes.filter((id) => id !== userId);

    // update the guide with the new upVotes and downVotes
    updateData({ upVotes, downVotes },`bonsai-guides`,guideId, handleVoteSuccess, handleVoteFail);

  }
  const handleDownvote = () => {
    
    if (!currentUser) {
      alert("You must be signed in to upvote a guide");
      return;
    }
    // get the current user id
    const userId = currentUser.uid;

    // if user not signed in alert them
    if (!userId) {
      alert("You must be signed in to downvote a guide");
      return;
    }

    // check if the user has already voted
    if (bonsaiGuide.downVotes && bonsaiGuide.downVotes.includes(userId)) {
      alert("You have already downvoted this guide");
      return;
    }

    const currentUpvotes = bonsaiGuide.upVotes || [];

    const currentDownvotes = bonsaiGuide.downVotes || [];

    // add the user id to the downVotes array
    const downVotes = [...currentDownvotes, userId];

    // if user id is in the upVotes array, remove it
    const upVotes = currentUpvotes.filter((id) => id !== userId);

    // update the guide with the new upVotes and downVotes
    updateData({ upVotes, downVotes },`bonsai-guides`, guideId, handleVoteSuccess, handleVoteFail);
  }

  const pdfName= `${bonsaiGuide.commonName} - ${bonsaiGuide.scientificName} Bonsai Guide.pdf`

  const haveBonsaiGuide = bonsaiGuide && bonsaiGuide.commonName;
  const showStage = (stage)=> {
    const stage1 = stage;
    // check that there is an elemnt in stage1 has decans length > 0
    let isFilled = false;
    if (stage1){
      stage1.forEach((row) => {
        if (row.decans.length > 0){
          isFilled = true;
        }
      });
    }
    return isFilled;

  
  }

  const isMyGuide = currentUser && currentUser.uid === bonsaiGuide.userId;

  const handleDeleteGuide = () => {
    if (window.confirm("Are you sure you want to delete this guide?")) {
      // delete the guide from firestore
      deleteData(`bonsai-guides`, guideId, () => {
        // navigate to the home page
        navigate(-1);
      });
    }
  }

  return (
    <Box>
      <AppBarGuide 

        allowVoting = {!isMyGuide}
        onUpvote={handleUpvote}
        onDownvote={handleDownvote}
        votes={{upVotes: bonsaiGuide.upVotes, downVotes: bonsaiGuide.downVotes}}
      
      />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      > 

      <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          Bonsai Guide
        </Typography>
        {/* {if timeDateCreated} */}
        {bonsaiGuide.timeDateCreated && (
          <Typography>
            Created on {firebaseDateToDateTime(bonsaiGuide.timeDateCreated.seconds).toDateString()}
          </Typography>
        )}
        {/* <Typography>
          Created on {firebaseDateToDateTime(bonsaiGuide.timeDateCreated.seconds).toDateString()}
        </Typography> */}
        <Typography variant="body1" style={{ marginBottom: "1rem" }}>
          For the <span style={{ fontStyle: "italic", fontWeight:600 }}>  {bonsaiGuide.stage} </span> of the 
          <span style={{ fontStyle: "italic", fontWeight:600 }}> {bonsaiGuide.commonName} ({bonsaiGuide.scientificName})</span> bonsai tree.
        </Typography>

        {/* <Typography variant="h4" style={{ marginBottom: "1rem" }}>
          {bonsaiGuide.commonName} 
          <span style={{ fontStyle: "italic", fontSize:"1.2rem" }}>
            - {bonsaiGuide.scientificName}
          </span>
        </Typography> */}
        <Divider style={{ marginTop: "1rem" }} />

        <Grid container
        style={{
          // padding: "2rem",
        }}>
          <Grid item xs={12}
          sm={6}
            style={{
              // center
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "2rem"
            }}
          >
            <Typography variant="h5" style={{ marginBottom: "1rem" }}>
              Soil Composition
            </Typography>
            <BonsaiSoilCompositionGraph
              soilComposition={bonsaiGuide.soilComposition}
            />
          </Grid>
          <Grid item xs={12} sm={6}
          
          style={{
            // center
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "2rem"
          }}>
            <Typography variant="h5" style={{ marginBottom: "1rem" }}>
              Location
            </Typography>
            {/* map */}
            { bonsaiGuide.geo && (
              <LeafletMapRestricted
                center={[bonsaiGuide.geo.latitude, bonsaiGuide.geo.longitude]}
              />
            )

            }
            {/* <LeafletMapRestricted
            center={(bonsaiGuide.geo)?[bonsaiGuide.geo.latitude, bonsaiGuide.geo.longitude] :[0,0]}
             /> */}

          </Grid>
        </Grid>

        <Typography variant="h5" style={{ marginBottom: "1rem" }}>
          Soil Comments
        </Typography>
        <Typography variant="body1" style={{ marginBottom: "1rem" }}>
          {bonsaiGuide.soilComment}
        </Typography>

        <Divider style={{ marginTop:"1rem",marginBottom: "1rem" }} />
        {/* if stage 1 exists */}
        {haveBonsaiGuide && showStage(bonsaiGuide["stage1"]) && (
          <Fragment>
        <Stage
          stage={bonsaiGuide.stage}
          data={bonsaiGuide.stage1}
          comment={bonsaiGuide.yearlyChartComment}
          />
          
        
        </Fragment>
        )}
        
        <Divider style={{ marginBottom: "1rem", marginTop: "1rem" }} />
        <Typography variant="h5"
        style={{
          marginBottom: "1rem",
        
        }} 
        >Actions</Typography>
        <Grid
         container>
          {isMyGuide && (
          <Grid item xs={4} 
        style={{
          alignContent: "center",
        }}>
            {/* Delete button */}
            <Button
              variant="contained"
              color="error"
              onClick={handleDeleteGuide}
            >
              Delete
            </Button>
          </Grid>
          )}
          {isMyGuide && (
          <Grid item xs={4}
        style={{
          textAlign: "center",
        }}>
            {/* Delete button */}
            <Button
              variant="contained"
              // color="error"
              onClick={() => {
                navigate(`/bonsai-guide/${guideId}/edit`);
              }}
            >
              Edit
            </Button>
          </Grid>
          )}
          <Grid item xs={isMyGuide? 4 : 12}>
            {!loading && (
      <PDFDownloadLink
      style={{
        float: isMyGuide? "right" : "left",
      }}
        document={<GuidePdf guide={bonsaiGuide} />}
        fileName={pdfName}
      >
        {({ blob, url, loading, error }) => (
        <Button variant="contained" color="secondary"
          disabled={!true}
        >
          {isMyGuide? "PDF" : "Download PDF"}
        </Button>
      )}
      </PDFDownloadLink> 
            )} 
      </Grid>
      </Grid>





    
        {loading && (
          <Box
            style={{
              textAlign: "center",
              margin: "2rem 0rem",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        
      </Box>
    </Box>
  );
}

export default ScreenGuide;
